import React, { Component } from 'react';
import Service from '../../services';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import BranchToSectionDDPreFill from '../BaseDropdownComponents/BranchToSectionDDPreFill';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { exportToExcel } from '../../utils/excelExport';

class StudentErrorReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            exams: [],
            selectedExam: null,
            filteredData: [],
            rawData: [],
            dataTableKey: 0,
            tableLoading: false,
            dropdownsData: {},
            students: [],
            selectedStudent: null,
        };
        this.service = new Service();
    }

    getStudentErrorReport() {
        const { dropdownsData } = this.state;
        this.setState({ tableLoading: true });

        this.service.post(`${baseUrlAdmin}/academicsReports/studentErrorReport`, {
            academicYear: localStorage.getItem('userAcademicYear'),
            branchId: dropdownsData.branchId,
            sectionId: dropdownsData.sectionId
        }, true)
            .then((response) => {
                if (response.status && response?.res?.status) {
                    const exams = response.res.data.map(item => ({
                        examId: item.examId,
                        examName: item.examName
                    })).filter((exam, index, self) =>
                        index === self.findIndex((e) => e.examId === exam.examId)
                    );

                    this.setState({
                        rawData: response.res.data,
                        exams,
                        tableLoading: false,
                        selectedExam: null,
                        filteredData: []
                    });
                } else {
                    this.setState({ tableLoading: false });
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                this.setState({ tableLoading: false });
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch report data',
                    life: 3000
                });
            });
    }

    onExamChange = (selectedExam) => {
        const filteredStudents = this.state.rawData
            .filter(item => item.examId === selectedExam.examId)
            .map(item => ({
                userId: item.userId,
                userName: item.userName,
                rollNo: item.enrollmentId
            }))
            .filter((student, index, self) =>
                index === self.findIndex((s) => s.userId === student.userId)
            );

        this.setState({
            selectedExam,
            students: filteredStudents,
            selectedStudent: null,
            filteredData: []
        });
    };

    onStudentChange = (selectedStudent) => {
        this.setState({
            selectedStudent
        });
    };

    onViewAnalysis = () => {
        const { rawData, selectedExam, selectedStudent } = this.state;

        // Check if both exam and student are selected
        if (!selectedExam) {
            this.toast?.show({
                severity: 'warn',
                summary: 'Please Select',
                detail: 'Please select an exam',
                life: 3000
            });
            return;
        }

        if (!selectedStudent) {
            this.toast?.show({
                severity: 'warn',
                summary: 'Please Select',
                detail: 'Please select a student to view their analysis',
                life: 3000
            });
            return;
        }

        this.setState({ tableLoading: true });

        const studentRecord = rawData.find(item =>
            item.examId === selectedExam.examId &&
            item.userId === selectedStudent.userId
        );

        // Flatten all questions from all subjects, adding subjectName to each question
        let questionsData = [];
        if (studentRecord && Array.isArray(studentRecord.subjects)) {
            studentRecord.subjects.forEach(subject => {
                if (Array.isArray(subject.questions)) {
                    subject.questions.forEach((q, idx) => {
                        questionsData.push({
                            ...q,
                            subjectName: subject.subjectName,
                            questionNo: q.questionSerialNo
                        });
                    });
                }
            });
        }

        // Update state with the processed data
        this.setState({
            filteredData: questionsData,
            dataTableKey: this.state.dataTableKey + 1,
            tableLoading: false
        });
    };

    setDropdownValues = (dropdownsData) => {
        this.setState({
            dropdownsData
        }, () => {
            if (dropdownsData.branchId && dropdownsData.sectionId) {
                this.getStudentErrorReport();
            }
        });
    }

    prepareDataForExcel = (questionsData) => {
        const { selectedStudent } = this.state;

        if (!questionsData || questionsData.length === 0) return [];

        return questionsData.map(q => {
            // Format user answer and correct answer for better display
            let userAnswer = Array.isArray(q.userAnswer)
                ? q.userAnswer.join(', ')
                : q.userAnswer || 'Not Answered';

            let correctAnswer = Array.isArray(q.correctAnswer)
                ? q.correctAnswer.join(', ')
                : q.correctAnswer || '';

            // Create a clean object with exact field names matching exportColumns
            return {
                'Student ID': selectedStudent?.userId || '',
                'Student Name': selectedStudent?.userName || '',
                'Question No': q.questionNo || '',
                'Subject': q.subjectName || '',
                'Question Type': q.questionType || '',
                'Difficulty Level': q.difficulty || '',
                'User Answer': userAnswer,
                'Correct Answer': correctAnswer,
                'Result': !q.isAnswered ? 'Unattempted' : (q.isCorrect ? 'Correct' : 'Wrong')
            };
        });
    };

    render() {
        const {
            exams,
            selectedExam,
            students,
            selectedStudent,
            filteredData,
            dataTableKey,
            tableLoading
        } = this.state;

        // Helper to render option status (supports both SCCT and MCCT)
        const renderOptionCell = (rowData, optionId) => {
            // For MCCT, userAnswer and correctAnswer are arrays
            const isMCCT = Array.isArray(rowData.userAnswer) && Array.isArray(rowData.correctAnswer);
            const userAnswered = rowData.isAnswered;
            let userAnswerArr = isMCCT ? rowData.userAnswer : [rowData.userAnswer];
            let correctAnswerArr = isMCCT ? rowData.correctAnswer : [rowData.correctAnswer];

            if (!userAnswered) {
                // Unattempted: show orange minus for all options (SVG)
                return (
                    <span style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                        <svg width="22" height="22" viewBox="0 0 22 22">
                            <rect x="3" y="3" width="16" height="16" rx="6" fill="#F57C1F" />
                            <rect x="7" y="10" width="8" height="2" rx="1" fill="#fff" />
                        </svg>
                    </span>
                );
            }

            const userSelected = userAnswerArr && userAnswerArr.includes(optionId);
            const correctSelected = correctAnswerArr && correctAnswerArr.includes(optionId);

            if (userSelected && correctSelected) {
                // Correct answer selected: green tick SVG
                return (
                    <span style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                        <svg width="20" height="20" viewBox="0 0 20 20">
                            <polyline points="4,11 9,16 16,5" fill="none" stroke="#28a745" strokeWidth="2.5" />
                        </svg>
                    </span>
                );
            } else if (userSelected && !correctSelected) {
                // Wrong answer selected, show red square
                return <span style={{ color: 'red', fontSize: 20 }}>🟥</span>;
            } else {
                // All other options: empty square
                return <span style={{ color: '#bbb', fontSize: 20 }}>⬜</span>;
            }
        };

        // Helper to get level from difficulty
        const getLevel = (difficulty) => {
            if (difficulty === 'Easy') return 1;
            if (difficulty === 'Medium') return 2;
            if (difficulty === 'Hard') return 3;
            return '';
        };

        // Use filteredData directly for DataTable
        const questionsData = filteredData;

        return (
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                padding: '0',
                marginLeft: "100px",
                marginTop: "55px",
                overflow: 'auto',
            }}>
                <div className="card filters-card mt-1 pt-0">
                    <BranchToSectionDDPreFill setValues={this.setDropdownValues} />

                    <div className="grid m-2">
                        <div className="col-3">
                            <label className='label'>Exam <span style={{ color: 'red' }}>*</span></label>
                            <div className="mt-2">
                                <ClassetDropdown
                                    value={selectedExam}
                                    options={exams}
                                    onChange={(e) => this.onExamChange(e.value)}
                                    optionLabel="examName"
                                    placeholder="Select Exam"
                                    disabled={!exams.length}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <label className='label'>Student <span style={{ color: 'red' }}>*</span></label>
                            <div className="mt-2">
                                <ClassetDropdown
                                    value={selectedStudent}
                                    options={students}
                                    onChange={(e) => this.onStudentChange(e.value)}
                                    optionLabel="userName"
                                    placeholder="Select Student"
                                    disabled={!students.length}
                                />
                            </div>
                        </div>
                        <div className="col-3 mt-5">
                            <Button
                                label="Download Report"
                                onClick={() => {
                                    const excelData = this.prepareDataForExcel(questionsData);
                                    const exportColumns = [
                                        { field: 'Student ID', header: 'Student ID' },
                                        { field: 'Student Name', header: 'Student Name' },
                                        { field: 'Question No', header: 'Question No' },
                                        { field: 'Subject', header: 'Subject' },
                                        { field: 'Question Type', header: 'Question Type' },
                                        { field: 'Difficulty Level', header: 'Difficulty Level' },
                                        { field: 'User Answer', header: 'User Answer' },
                                        { field: 'Correct Answer', header: 'Correct Answer' },
                                        { field: 'Result', header: 'Result' }
                                    ];

                                    exportToExcel(
                                        excelData,
                                        `Student_Error_Report_${selectedStudent?.userName || 'Unknown'}_${selectedExam?.examName || 'Unknown'}`,
                                        exportColumns
                                    );
                                }}
                                disabled={!questionsData.length}
                                className="p-button-secondary mr-2"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#fff",
                                    color: "#076EFF",
                                    marginRight: "10px"
                                }}
                            />
                            <Button
                                label="View Analysis"
                                onClick={this.onViewAnalysis}
                                disabled={!selectedExam}
                                className="p-button-primary"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#076EFF",
                                    color: "#fff"
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className='datatable-report-demo mx-2'>
                    <DataTable
                        key={dataTableKey}
                        value={questionsData}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                        responsiveLayout="scroll"
                        className="p-datatable-custom"
                        loading={tableLoading}
                        loadingIcon="pi pi-spinner"
                        showLoader={false}
                        emptyMessage={
                            <div style={{ textAlign: 'center', padding: '1rem' }}>
                                No results found
                            </div>
                        }
                    >
                        <Column field="questionNo" header="Question No" style={{ width: 100 }} />
                        <Column field="subjectName" header="Subject" style={{ width: 120 }} />
                        <Column header="Option 1" body={rowData => renderOptionCell(rowData, "A")} style={{ width: 90, textAlign: 'center' }} />
                        <Column header="Option 2" body={rowData => renderOptionCell(rowData, "B")} style={{ width: 90, textAlign: 'center' }} />
                        <Column header="Option 3" body={rowData => renderOptionCell(rowData, "C")} style={{ width: 90, textAlign: 'center' }} />
                        <Column header="Option 4" body={rowData => renderOptionCell(rowData, "D")} style={{ width: 90, textAlign: 'center' }} />
                        <Column header="Correct / Wrong / UA" body={rowData => {
                            if (!rowData.isAnswered) return "UA";
                            return rowData.isCorrect ? "Correct" : "Wrong";
                        }} style={{ width: 150 }} />
                        <Column header="Question Level" body={rowData => getLevel(rowData.difficulty)} style={{ width: 120 }} />
                        <Column field="correctAnswer" header="Key" style={{ width: 80 }} />
                    </DataTable>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </div>
        );
    }
}

export default StudentErrorReport;